import { eventChannel } from 'redux-saga';

export default (livescore) => eventChannel(emitter => {
  const connectHandler = () => emitter({ type: 'connect' });
  const errorHandler = reason => emitter({ type: 'connect_error', reason });
  const warningHandler = reason => emitter({ type: 'connect_warning', reason });
  const reconnectHandler = () => emitter({ type: 'reconnect' });
  const disconnectHandler = reason => emitter({ type: 'disconnect', reason });
  const dataHandler = event => emitter(event);

  livescore.on('connect', connectHandler);
  livescore.on('connect_error', errorHandler);
  livescore.on('connect_warning', warningHandler);
  livescore.on('reconnect', reconnectHandler);
  livescore.on('disconnect', disconnectHandler);
  livescore.on('data', dataHandler);

  return () => {
    livescore.off('connect', connectHandler);
    livescore.off('connect_error', errorHandler);
    livescore.off('connect_warning', warningHandler);
    livescore.off('reconnect', reconnectHandler);
    livescore.off('disconnect', disconnectHandler);
    livescore.off('data', dataHandler);
  };
});
